import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        borderBottom: `1px solid ${theme.palette.border.select}`,
        marginBottom: 48,
        backgroundColor: theme.palette.primary.main,
        padding: "24px",
    },
    label: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: 6,
    },
    select: {
        maxWidth: 237,
        backgroundColor: theme.palette.primary.main,
        "& fieldset": {
            borderColor: theme.palette.border.select,
        },
        "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            "&.MuiInputBase-input": {
                flexDirection: "column",
                alignItems: "self-start",
            },
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.primary.darker,
            fontFamily: "Source Sans 3",
            padding: "9px 12px",
        },
    },
    selectNoFlex: {
        "& .MuiSelect-select": {
            display: "block",
        },
    },
    filtersWrapper: {
        display: "grid",
        rowGap: 12,
        columnGap: 8,
        gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
    },
    filtersActionsWrapper: {
        marginTop: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 12,
    },
    selectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    datePickersWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    datePicker: {
        minHeight: "1.4375em",
        minWidth: 230,
        padding: "12px 12px !important",
        fontSize: 14,
        border: `1px solid ${theme.palette.border.select} !important`,
        borderRadius: 4,
    },
    mainWrapperLoading: {
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        display: "flex",
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
        gap: 4,
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    link: {
        display: "flex",
        gap: 16,
        color: theme.palette.info.main,
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: 12,
        textDecorationLine: "underline",
        textTransform: "uppercase",
        cursor: "pointer",
    },
}));
